
/* injects from baggage-loader */

'use strict';

export default class AccountDocumentsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		// this.$log.log(this.documents);
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/documents/account.documents.controller.js